import React from "react";

//Nav bar component
export default function Navbar() {
  return (
    <nav>
      <nav className="navbar navbar-dark bg-dark mb-5">
        <span className="navbar-brand mb-0 h1 mx-auto"></span>
      </nav>
    </nav>
  );
}
